import React from 'react';
import cx from 'classnames';

import { hookFormFieldHoc, HookFormFieldCoreProps } from '../field.hoc';

export interface ButtonProps extends HookFormFieldCoreProps {
  children?: React.ReactNode;
  value: string;
  nlogAreaCode?: string;
}

const ButtonField: React.FC<ButtonProps> = ({ field, className, children, value, nlogAreaCode }) => {
  const onClick = (value: any) => () => {
    field?.onChange?.(value);
  };

  return (
    <button
      id={value}
      type="button"
      onClick={onClick(value)}
      className={cx(className)}
      {...field}
      aria-selected={field?.value === value}
      {...(nlogAreaCode ? { 'data-event-nlog': 'click', 'data-event-area-code': nlogAreaCode } : {})}
      data-event-nlog="click"
    >
      {children}
    </button>
  );
};

export default hookFormFieldHoc(ButtonField);
